export type NavigationMode = {
  code: string;
  name: string;
};

export const SUPPORTED_MODE: NavigationMode[] = [
  { code: "walk", name: "Shortest Walk" },
  { code: "wheelchair", name: "Wheelchair" },
  { code: "robot", name: "Robot" },
  { code: "drone", name: "Drone" },
];

export const DEFAULT_NAV_MODE = "walk";
export const DEFAULT_USE_STAIRS = false;

export const CHAT_TYPE = {
  NAVIGATION: "navigation",
  SIMULATION: "simulation",
  EXPLORATION: "exploration",
} as const;
